export interface MapStyle {
  id: string;
  name: string;
  url: string;
  description?: string;
  thumbnail?: string;
}

export const MAP_STYLES: MapStyle[] = [
  {
    id: "cbreLight",
    name: "CBRE Light",
    url: "mapbox://styles/cbre-lig/cjykc8tc90sny1cotxp3lwmhw",
  },
  {
    id: "cbreDark",
    name: "CBRE Dark",
    url: `mapbox://styles/cbre-lig/ckltq1qby1h7017o1g25f2e05`,
  },
  {
    id: "emeraldEsriHybrid",
    name: "Esri Hybrid",
    url: "/map-styles/emerald-esri-hybrid.json",
  },
  {
    id: "emeraldBingHybrid",
    name: "Bing Hybrid",
    url: "/map-styles/emerald-bing-hybrid.json",
  },
  {
    id: "mapboxStreets",
    name: "Mapbox Streets",
    url: "mapbox://styles/mapbox/streets-v10",
  },
  {
    id: "mapboxGray",
    name: "Mapbox Grey",
    url: "mapbox://styles/mapbox/light-v9",
  },
  {
    id: "mapboxDark",
    name: "Mapbox Dark",
    url: "mapbox://styles/mapbox/dark-v9",
  },
];
